import { ReactNode, useEffect } from "react";
import '../../styles/EventsStyles/EventsPlatform.css';
import EventsHeader from "./EventsHeader";
import EventsFooter from "./EventsFooter";
import PrototypeNotice from "./PrototypeNotice";
import WhatsAppChat from "../WhatsAppChat";

interface EventsLayoutProps {
  /** Shown in the browser tab before "Kole Medical Webinars & Workshops" */
  title?: string;
  children: ReactNode;
}

// Shell for every /events page. Webinars & Workshops runs as its own platform:
// its own header, navigation, footer and page background, linked back to the main site.
export default function EventsLayout({ title, children }: EventsLayoutProps) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} | Kole Medical Webinars & Workshops` : "Kole Medical Webinars & Workshops";
    return () => { document.title = previous; };
  }, [title]);

  return (
    <div className="evp">
      <PrototypeNotice variant="public" />
      <EventsHeader />
      <main className="evp-main">{children}</main>
      <EventsFooter />
      <WhatsAppChat />
    </div>
  );
}
